import { fetchGtmData } from "@/lib/tradeCards";
import Image from "next/image";
import { useEffect, useState } from "react";
import {
    Dialog,
    DialogTrigger,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
} from "@/components/ui/dialog";
import movieIcon from "@/assets/icons/movieIcon.svg";
import helpIcon from "@/assets/icons/helpIcon.svg";
import { cn } from "@/lib/utils";
import { BsChevronRight } from "react-icons/bs";

const GtmPopUp = ({ children }) => {
    const [open, setOpen] = useState(false);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger>{children}</DialogTrigger>
            <DialogContent
                className="gap-0 flex flex-col font-Inter overflow-hidden bg-[#FCFCFC]"
                iconclassname="hidden"
            >
                <GtmVideoList open={open} />
            </DialogContent>
        </Dialog>
    );
};

export function GtmVideoList({ open, isTradeHistoryPopUp = false }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (open && !data) {
            fetchGtmData().then(setData);
        }
    }, [open]);
    return (
        <div className="flex w-full flex-col items-start gap-3 ">
            <div className="flex justify-between w-full">
                <p className="text-[#202020] text-center text-sm font-bold ">Learn more</p>

                {isTradeHistoryPopUp && (
                    <GtmPopUp>
                        <div className="text-primary text-center text-xs font-medium leading-5 flex flex-row gap-2 justify-center items-center">
                            View all <BsChevronRight />
                        </div>
                    </GtmPopUp>
                )}
            </div>
            <div className="flex flex-row gap-2 overflow-x-auto">
                {data?.gtm?.subSectionVideosList?.map((ele, i) => (
                    <Image
                        onClick={() => window.open(ele?.videoUrl)}
                        key={i}
                        src={ele?.imageUrl}
                        width={1000}
                        height={1000}
                        className={cn("cursor-pointer w-48 object-contain", { "w-36": isTradeHistoryPopUp })}
                        alt="subSectionVideosList"
                    />
                ))}
            </div>
            {!isTradeHistoryPopUp && (
                <>
                    <div className="flex items-center gap-2 px-6">
                        <Image
                            src={movieIcon}
                            alt="ll"
                            className="w-7 object-contain bg-gradient-to-tr from-[#243B55] to-[#333] p-[5px] rounded-full"
                        />
                        <p className="text-[#202020] text-center text-base font-bold leading-8">
                            Understanding an option idea
                        </p>
                    </div>
                    <div className="flex flex-row gap-2 overflow-x-auto px-6">
                        {data?.gtm?.gtmImagesList?.map((ele, i) => (
                            <Image
                                key={i}
                                src={ele}
                                width={1000}
                                height={1000}
                                className={cn("cursor-pointer w-48 object-contain", { "w-36": isTradeHistoryPopUp })}
                                alt="gtmImagesList"
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

export default GtmPopUp;
